import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ClientService } from 'src/app/private/services/client.service';
import { PackageService } from 'src/app/private/services/package.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { AssignAddonComponent } from '../../packages/assign-addon/assign-addon.component';
import { Menu } from 'primeng/menu';
import { AddonService } from 'src/app/private/services/addon.service';
import { MessageService } from 'primeng/api';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-client-addons',
  imports: [SharedModule,AssignAddonComponent],
  templateUrl: './client-addons.component.html',
  styleUrl: './client-addons.component.scss'
})
export class ClientAddonsComponent {

@Input() clientId: string = '';
  @Output() editAssignAddon = new EventEmitter<any>();
  @Output() deleteAssignAddon = new EventEmitter<any>();
  @Output() openAssignAddon = new EventEmitter<any>();
  
  @ViewChild('menu') menu!: Menu;
  
  displayAddModal: boolean = false;
  clientDataToEdit: any = null;
  showDeleteModal: boolean = false;
  displayEditModel: boolean = false;
  selectedClientPackage : any = {}
  selectedAddon: any = null;
  allPackages: any[] = [];
 isDeleting : boolean = false;
  rows = 50;
  totalRecords = 0;
  loading = false;

  menuItems: any[] = [];

  constructor(
    private clientService: ClientService,
    private addonService: PackageService,
    private assignAddonService: AddonService,
    private messageService: MessageService,
    private lcoalStorage: LocalStorageService
  ) { }

  clientPackage: any;


  ngOnInit() {
    this.getClientAddonsSubscription();
  }

  openAddModal() {
    this.openAssignAddon.emit()
  }


  getClientAddonsSubscription() {
    const payload = {
      "page": 0,
      "limit": 10,
      "where": {},
    "order": {
        "col": "\"addon_subscription\".\"updatedAt\"",
        "dir": "DESC"
    }
    }

    this.loading = true;

    this.addonService.getAllAddonSubscription(payload).subscribe({
      next: (res : any) => {
        if(res){
          this.clientPackage = res.rows;
        }else{
          this.clientPackage = [];
        }
        console.log("cltpackage",this.clientPackage);
        this.totalRecords = this.clientPackage.length;
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
      }
    });

    

  }

  reload() {
    this.getClientAddonsSubscription();
  }


  

setDelete
(clientData: any) {
    this.clientDataToEdit = clientData;
    this.showDeleteModal = true
    //this.deleteClientPackage.emit(clientData)
  }
  setClientData(clientData: any) {
    this.clientDataToEdit = clientData;
    this.editAssignAddon.emit(clientData)
  }

  openMenu(event: any, addonData: any) {
    this.selectedAddon = addonData;
    
    this.menuItems = [
      {
        label: 'Edit Addon',
        icon: 'pi pi-pencil',
        command: () => {
          this.setClientData(addonData);
        }
      },
      {
        label: 'Create Invoice',
        icon: 'pi pi-file-edit',
        command: () => {
          this.createInvoice(addonData);
        }
      },
      {
        separator: true
      },
      {
        label: 'Delete Addon',
        icon: 'pi pi-trash',
        command: () => {
          this.setDelete(addonData);
        }
      }
    ];

    this.menu.toggle(event);
  }

  createInvoice(addonData: any) {
    const payload = {
      addon_subscription_id: addonData.id,
      client_id: addonData.client_id
    }

    this.loading = true;
    this.assignAddonService.proformaAddonInvoice(payload).subscribe({
      next: (res : any) => {
        if(res){
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Invoice created successfully',
          });
        }else{
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Invoice creation failed',
          });
        }
        console.log("cltpackage",this.clientPackage);
        this.totalRecords = this.clientPackage.length;
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
      }
    });

    
    // TODO: Implement invoice creation logic
    console.log('Creating invoice for addon:', addonData);
    
    // You can emit an event or navigate to invoice creation page
    // For now, just logging the data
    // this.router.navigate(['/invoices/create'], { 
    //   queryParams: { addonId: addonData.id } 
    // });
  }


 deleteAddonConfirm(){
    // const payload = {
    //   id: this.clientDataToEdit.id,
    // }

    // this.loading = true;
    // this.packageService.deletePackageSubscription(payload).subscribe({
    //   next: (res) => {
    //     this.loading = false;
    //       this.reload();
    //       this.showDeleteModal = false
    //   },
    //   error: (err) => {
    //     this.loading = false;
    //   }
    // });
  
 }


}
